import React, { useState, useRef } from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import swal from 'sweetalert';
import { isNull } from 'lodash';
import { toast } from 'react-toastify';
import { useStoreState } from 'easy-peasy';

import client from '../../../utils/apolloClient';
import { ErrorMessage } from '../../../components/elements';
import Layout from '../../../components/global/Layout';
import PlaceSelection from '../../../components/PlaceSelection';
import Form from './Form';

const createMenuModifierGroupMutation = gql`
  mutation createMenuModifierGroup($input: MenuModifierGroupInput) {
    create_menu_modifier_group(input: $input) {
      modifier_group_id
      error {
        description
      }
    }
  }
`;

const ModifiersGroupAdd = ({ history }) => {
  const { userId } = useStoreState(state => state.auth);
  const { defaultPlace } = useStoreState(state => state.menu);
  const [place, setPlace] = useState({});
  const [placeSelection, setPlaceSelection] = useState(false);
  const [saveAndAddMore, setSaveAndAddMore] = useState(false);
  const resetFormFunc = useRef(() => {});

  const placeData = defaultPlace ?? place;
  const placeSelectionValue =
    defaultPlace !== null ? !!defaultPlace : placeSelection;

  return (
    <Layout>
      {placeSelectionValue ? (
        <Mutation
          client={client.clientPrivate}
          mutation={createMenuModifierGroupMutation}
          onCompleted={({ create_menu_modifier_group }) => {
            if (!isNull(create_menu_modifier_group.error)) {
              create_menu_modifier_group.error.map(item =>
                toast.error(item.description),
              );
            } else {
              swal(
                'Great!',
                'Menu  Modifier group created successfully!',
                'success',
              ).then(() => {
                if (saveAndAddMore) {
                  if (resetFormFunc.current) {
                    resetFormFunc.current();
                  } else {
                    history.go(0);
                  }
                } else {
                  history.goBack();
                }
              });
            }
          }}
        >
          {(create_menu_modifier_group, { loading, error }) => (
            <>
              {error && <ErrorMessage message={error.message} />}
              <Form
                saveAndAddMore={saveAndAddMore}
                setSaveAndAddMore={setSaveAndAddMore}
                isAdd
                userId={userId}
                place={placeData}
                loading={loading}
                onSubmit={(inputs, resetForm) => {
                  resetFormFunc.current = resetForm;
                  create_menu_modifier_group({
                    variables: {
                      input: inputs,
                    },
                  });
                }}
              />
            </>
          )}
        </Mutation>
      ) : (
        <PlaceSelection
          claimStatus="NONE"
          hasServiceSetting
          heading="Select place to add a modifier group"
          handleSelect={value => {
            setPlace(value);
            setPlaceSelection(true);
          }}
        />
      )}
    </Layout>
  );
};

export default ModifiersGroupAdd;
